import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./ButtonDesign.css";

const ButtonDesign = ({ data, handleClick }) => {
	const navigate = useNavigate();
	const [activated, setActivated] = useState(true);
	const [buttonStyles, setButtonStyles] = useState({});

	const handleNavigation = (e, page) => {
		e.preventDefault();

		if (window.location.pathname === "/" + page) {
			window.location.reload();
		} else if (window.location.pathname === "/" && page === " ") {
			window.location.reload();
		} else {
			navigate("/" + page);
		}
	};

	const handleButton = (e, action, to) => {
		e.preventDefault();
		if (action === "redirect" && to) {
			handleNavigation(e, to);
		}
	};

	useEffect(() => {
		if ("dynamic" in data && data["dynamic"] === true) {
			if (
				"form" in data &&
				"name" in data["form"] &&
				"subject" in data["form"] &&
				"email" in data["form"] &&
				"message" in data["form"] &&
				data["form"]["name"] !== "" &&
				data["form"]["subject"] !== "" &&
				data["form"]["email"] !== "" &&
				data["form"]["message"] !== "" &&
				data["form"]["email"].includes("@")
			) {
				setActivated(true);
			} else {
				setActivated(false);
			}
		}
		if ("styles" in data) {
			setButtonStyles(data["styles"]);
		}
	}, [data]);

	return (
		<div
			className={`${activated ? "button-design" : "button-disabled"}`}
			style={{ width: buttonStyles["width"], height: buttonStyles["height"] }}
			onClick={(e) => {
				if (activated) {
					handleButton(e, data["action"], data["to"]);
					if (handleClick) {
						handleClick();
					}
				}
			}}
		>
			<p className="button-design-text">
				<h5>{data["text"]}</h5>
			</p>
			{data["icon"] && (
				<img
					alt={"go"}
					src={require("../../assets/icons/up.webp")}
					className="button-design-icon"
				/>
			)}
		</div>
	);
};

export default ButtonDesign;
